import { createSlice } from "@reduxjs/toolkit";

export const reduxIgong = createSlice({
    name: 'name_reduxIgong',//변경해도 의미 없네 (내부적으로 식별 용도인 듯)
    initialState: {   
        // data: [],
        // colNum: 20,
        // wordCount: [],
        activeLink: 'home',
        isAdmin: false,
        isLoggedIn: true,
        isSubmenuVisible: false,
        userInfo:{},
        userName: '',
        userKind: '',
        selectedTestCode: null,
        selectedStCode: null,
        selectedUserName: null,
        selectedUserInfo:{},
        isStudent: false,
        videoEduKind: null,
        selectedParentCode_ujab: null,
    
    },
    
    reducers: {

        // setData: (state, action) => {
        //     state.data = action.payload;
        // },

        // setColNum: (state, action) => {
        //     state.colNum = action.payload;
        // },

        // setWordCont: (state, action) => {
        //     state.wordCount = action.payload;
        // },

        setActiveLink: (state, action) => {
                state.activeLink = action.payload;
        },

        setSelectedClassList: (state, action) => {
            state.selectedClassList = action.payload;
        },
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setIsSubmenuVisible: (state, action) => {
            state.isSubmenuVisible = action.payload;
        },

        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },

        setUserName: (state, action) => {
            state.userName = action.payload;
        },

        setUserKind: (state, action) => {
            state.userKind = action.payload;
        },

        setSelectedTestCode: (state, action) => {
            state.selectedTestCode = action.payload;
        },

        setSelectedStCode: (state, action) => {
            state.selectedStCode = action.payload;
        },

        setSelectedUserName: (state, action) => {
            state.selectedUserName = action.payload;
        },

        setSelectedUserInfo: (state, action) => {
            state.selectedUserInfo = action.payload;
        },
        setIsStudent: (state, action) => {
            state.isStudent = action.payload;
        },
        setVideoEduKind: (state, action) => {
            state.videoEduKind = action.payload;
        },
        setSelectedParentCode_ujab: (state, action) => {
            state.selectedParentCode_ujab = action.payload;
        },
        
        
    }


});



export const { 
    // setData, 
    // setColNum,
    // setWordCont,
    setActiveLink,
    setIsAdmin,
    setIsLoggedIn,
    setIsSubmenuVisible,
    setUserInfo,
    setUserName,
    setUserKind,
    setSelectedTestCode, setSelectedStCode, setSelectedUserName,
    setSelectedUserInfo, setIsStudent,
    setVideoEduKind,
    setSelectedParentCode_ujab,

} = reduxIgong.actions;

export default reduxIgong.reducer;

